export default __webpack_public_path__ + "static/realWorldImg3-e1487fb5d45ecfda8b2707bfb167e3a6.png";